import { Button, Flex, Icon, Stack, Text } from '@backyard-ui/core'
import { CrossOutline } from '@backyard-ui/icons'
import { useEffect } from 'react'

const PanicError = () => {
  const refreshPage = () => {
    window.location.reload()
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <Stack
      direction="column"
      align="center"
      justify="center"
      className="w-full my-8">
      <Flex
        align="center"
        justify="center"
        className="border-[3px] border-solid rounded-full w-10 h-10 border-red-500  ">
        <Icon size="sm" UNSAFE_className="text-red-500" data-testid="icon">
          <CrossOutline />
        </Icon>
      </Flex>
      <div>
        <Text size="xl" align="center" color="gray-900" weight="bold">
          Ocorreu um erro
        </Text>
        <Text size="sm" align="center" color="gray-600">
          Estamos trabalhando para realizar a correção.
        </Text>
        <Text size="sm" align="center" color="gray-600">
          Por favor, tente novamente.
        </Text>
      </div>
      <Button onClick={refreshPage}>Tentar novamente</Button>
    </Stack>
  )
}

export default PanicError
